import { store } from "../../../redux/store/configureStore";
export var logout = function(navigate) {
    var direction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "/login";
    localStorage.removeItem("accessToken");
    store.dispatch({
        type: "USER_LOGOUT"
    });
    navigate(direction);
};
